import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'] // Ensure your .scss file exists or change to .css if necessary
})
export class PasswordRecoveryComponent implements OnInit {
  passwordForm!: FormGroup;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.passwordForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
      confirmPassword: new FormControl('', [Validators.required])
    }, { validators: this.passwordMatchValidator });
  }

  // Ensure the validator is correctly defined to check if passwords match
  passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const form = control as FormGroup;
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      return { passwordsDoNotMatch: true }; // Correctly return an error object when passwords do not match
    }
    return null; // Return null when no errors
  };

  onSubmit(): void {
    if (this.passwordForm.valid) {
      console.log('Form Data:', this.passwordForm.value);
      // Here you would handle the password update logic, such as calling a service to update the password
      // Assume password update is successful and redirect to login page
      this.router.navigate(['/']).then(() => {
        console.log('Redirected to login page');
      });
    } else {
      console.log('Form Errors:', this.passwordForm.errors);
    }
  }
}